import { defineCustomElement } from '@tyler-components-web/core';
import { LinearProgressComponent } from './linear-progress';
export * from './linear-progress-constants';
export * from './linear-progress';
export function defineLinearProgressComponent() {
    defineCustomElement(LinearProgressComponent);
}
